import { render, staticRenderFns } from "./marginReturnList.vue?vue&type=template&id=5a5dd3bf&scoped=true&"
import script from "./marginReturnList.vue?vue&type=script&lang=js&"
export * from "./marginReturnList.vue?vue&type=script&lang=js&"
import style0 from "./marginReturnList.vue?vue&type=style&index=0&id=5a5dd3bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5dd3bf",
  null
  
)

export default component.exports